import styled from 'styled-components';

const WrapProcedureList = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  .wrapArticle {
    width: 100%;
    display: flex;
  }
  .wrapArticle > * {
    width: 100%;
  }
  .gridCards {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    /* margin-top: 16px; */
  }
  article {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 14px 17px 14px 12px;
    width: 100%;
    min-height: 48px;
    background: #ffffff;
    box-shadow: 0px 2px 8px -4px rgba(176, 192, 202, 0.2);
    border-radius: 8px;
    justify-content: space-between;
  }
  button {
    display: flex;
    width: 100%;
  }

  article > * {
    display: flex;
  }
  article > div {
    /* max-width: 264px; */
  }
  article cc-icon {
    color: #5b36f2;
  }
  .linkItem {
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #5b36f2;
    align-items: center;
    display: flex;
    margin-top: 8px;
    cursor: default;
  }
  .linkItem cc-icon {
    display: flex;
    margin-right: 4px;
  }
  @media (min-width: 992px) {
    .gridCards {
      /* margin-top: 24px; */
    }
    .wrapArticle {
      margin-bottom: 16px;
      flex-grow: 1;
      flex-basis: 50%;
    }
    .wrapArticle:nth-child(even) {
      padding-left: 12px;
    }
    .wrapArticle:nth-child(odd) {
      padding-right: 12px;
    }

    .wrapArticle:last-child {
      flex-grow: inherit;
      flex-basis: 50%;
    }
    article {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 16px 24px 16px 16px;
      width: 100%;
      min-height: 44px;
      background: #ffffff;
      box-shadow: 0px 2px 8px -4px rgba(176, 192, 202, 0.2);
      border-radius: 8px;
      justify-content: space-between;
    }
  }
`;

export const ProcedureListGrid = styled.div`
  width: 100%;
  display: grid;
  grid-row-gap: 1rem;
  grid-column-gap: 1rem;
  grid-template-columns: repeat(1, 1fr);

  @media (min-width: 640px) {
    grid-row-gap: 8px;
    grid-column-gap: 16px;
    grid-template-columns: repeat(2, 1fr);
  }
`;

export { WrapProcedureList };
